export const MAX_CONCURRENT_REQUESTS = 6;
export const PREFETCH_CONCURRENCY_LIMIT = 4;
export const OVERVIEW_CACHE_SIZE = 48;
/* eslint-disable @typescript-eslint/no-magic-numbers */
export const PREFETCH_OFFSETS = [1, 2, 3, 4, 5, 6, 7, 8, -1, -2];
/* eslint-enable @typescript-eslint/no-magic-numbers */
export const PREFETCH_BATCH_MIN = 3;
export const PAGES_BATCH_MAX_SPAN = 15;
export const TILES_BATCH_MIN = 4;
export const MAX_BATCH_RENDER_PIXELS = 25_000_000;
export const TILE_EPSILON = 1e-6;
export const TILE_SIZE = 512;
export const IMAGE_FORMAT = 'webp';
export const RATE_LIMIT_MAX_RETRIES = 3;
export const RATE_LIMIT_BASE_DELAY_MS = 1000;
export const RATE_LIMIT_MAX_DELAY_MS = 8000;
export const RATE_LIMIT_MAX_RETRY_AFTER_MS = 30_000;
export const RATE_LIMIT_JITTER = 0.25;
export const RATE_LIMIT_BACKOFF_FACTOR = 2;
